import pako from "pako";

const textDecoder = new TextDecoder();

// Function to compress an object to a compressed string
export function compressObject(obj) {
  return pako.deflate(JSON.stringify(obj), { level: 5 }); // Uint8Array
}

export function decompressObject(bytes) {
  // pako's `{ to: "string" }` does the UTF-8 decode in JS. Handing it the raw bytes and
  // letting the platform's TextDecoder do that step measured 20-50% faster end to end on
  // recap blobs (paired A/B on the same blob per call; unpaired runs vary by 2.5x and
  // cannot resolve a difference this size).
  return JSON.parse(textDecoder.decode(pako.inflate(bytes)));
}

export function decodeArrayBufferToObject(arrayBuffer) {
  return JSON.parse(textDecoder.decode(arrayBuffer));
}

export function convertObjectToArrayBuffer(obj) {
  return new TextEncoder().encode(JSON.stringify(obj)).buffer;
}
